import type { Product } from '@/entities/product';
import type { SerpProduct, SerpResultsDictionaries } from '../model/types';

export function createEmptySerpResultsDictionaries(): SerpResultsDictionaries {
  return { operators: [], prepayments: [] };
}

export function addToSerpResultsDictionaries(
  dictionaries: SerpResultsDictionaries,
  products: readonly Product[],
): SerpResultsDictionaries {
  const operators = [...dictionaries.operators];
  const prepayments = [...dictionaries.prepayments];
  const operatorIds = new Set(operators.map(({ id }) => id));
  const prepaymentIds = new Set(prepayments.map(({ id }) => id));

  for (const { operator, firstPaymentDefinitions } of products) {
    if (operator && !operatorIds.has(operator.id)) {
      operatorIds.add(operator.id);
      operators.push(operator);
    }

    for (const definition of firstPaymentDefinitions ?? []) {
      if (!prepaymentIds.has(definition.id)) {
        prepaymentIds.add(definition.id);
        prepayments.push(definition);
      }
    }
  }

  const isChanged =
    operators.length !== dictionaries.operators.length || prepayments.length !== dictionaries.prepayments.length;

  return isChanged ? { operators, prepayments } : dictionaries;
}

export function getSerpResultsDictionaries(products: readonly SerpProduct[]): SerpResultsDictionaries {
  return addToSerpResultsDictionaries(
    createEmptySerpResultsDictionaries(),
    products.flatMap((serpProduct) => serpProduct.products),
  );
}
